<template>
  <v-app>
    <slot />
  </v-app>
</template>

<script>
export default {};
</script>

<style>
</style>